import React from 'react';
// import data from '../../aboutClinic.json';

// const { locationContact } = data;

const LocationContact = ({lunchText, rowsTobeMapped, locationContact}) => {
  const { id, heading, map, infoCards } = locationContact;

  return (
    <section id={id} className="w-full bg-white ava-section-gap">
      <div className="container mx-auto px-4 md:px-8">

        {/* ── Heading ── */}
        <h2 className="text-center ava-heading-lg ava-heading-gap">
          {heading}
        </h2>

        {/* ── Two-column layout ── */}
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 items-start max-w-6xl mx-auto">

          {/* ── Left: Map — takes more width (3/5) ── */}
          <div className="w-full lg:w-3/5 flex flex-col gap-4  ava-radius-md ">

            {/* Map embed */}
            <div
              className="w-full overflow-hidden ava-radius-md  border "
              style={{
                borderColor: 'var(--gray-200)',
                boxShadow: '0 2px 12px rgba(0,36,107,0.07)',
              }}
            >
              <iframe className=''
                src={map.embedUrl}
                width="100%"
                height="320"
                style={{ border: 0, display: 'block' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Clinic Location"
              />
            </div>

            {/* Directions & Parking */}
            <div className="flex flex-col gap-1 ">
              <h3
                className="ava-text-subheading"
              >
                {map.directionsTitle}
              </h3>
              <p
                className="ava-text-body"
              >
                {map.directionsText}
              </p>
            </div>
          </div>

          {/* ── Right: Info Cards — narrower (2/5) ── */}
          <div className="w-full lg:w-2/5 flex flex-col gap-4">
            {/* {infoCards.map((card) => (
              <InfoCard key={card.id} card={card} />
            ))} */}
            {infoCards.map((card) =>
              card.id === 'card-hours'
                ? <HoursCard key={card.id} card={card} rowsTobeMapped={rowsTobeMapped} lunchText={lunchText} />
                : <InfoCard key={card.id} card={card} />
            )}
          </div>

        </div>
      </div>
    </section>
  );
};

/* ── Clinic Hours Card ── */
const HoursCard = ({ card,rowsTobeMapped,lunchText }) => (
  <div
    className="ava-card-bg ava-card-mukta overflow-hidden"
    style={{ borderRadius: '20px', display: 'flex', minHeight: '180px' }}
  >
    {/* Left decorative panel */}
    <div
      style={{
        width: '155px',
        flexShrink: 0,
        background: 'linear-gradient(160deg, #fff5f7 0%, #fce4ec 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '28px 16px',
        gap: '10px',
        // Wavy right edge using clip-path
        // clipPath: 'polygon(0 0, 88% 0, 100% 15%, 88% 30%, 100% 45%, 88% 60%, 100% 75%, 88% 90%, 100% 100%, 0 100%)',
      }}
    >
      {/* Icon badge */}
      <div
        style={{
          width: '54px',
          height: '54px',
          borderRadius: '16px',
          backgroundColor: 'var(--secondary-color)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src={card.icon}
          alt={card.title}
          style={{ width: '28px', height: '28px', filter: 'brightness(0) invert(1)' }}
        />
      </div>

      <div style={{ textAlign: 'center' }}>
        <p className="ava-text-subheading" style={{  marginBottom: '4px' }}>
          {card.title} 
        </p>
        <p className="ava-text-xs" style={{ color: 'var(--ava-color-caption)', marginBottom: '8px' }}>
          We're here to serve you
        </p>
        {/* Pink underline accent */}
        <div
          style={{
            width: '32px',
            height: '3px',
            borderRadius: '2px',
            backgroundColor: 'var(--secondary-color)',
            margin: '0 auto',
          }}
        />
      </div>
    </div>

    {/* Right: schedule rows */}
    <div
      style={{
        flex: 1,
        padding: '0 20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      {rowsTobeMapped.map((row, idx) => (
        <React.Fragment key={row.id}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', padding: '14px 0' }}>
            {/* Calendar icon in soft pink circle */}
            <div>
              <p className="ava-text-subheading" style={{  marginBottom: '2px' }}>
                {row.label}
              </p>
              <p className="ava-text-xs" style={{ color: 'var(--ava-color-caption)' }}>
                {row.value}
              </p>
              {idx===0 &&(
                <p className='mt-1 ava-text-xs' style={{ color: 'var(--ava-color-caption)' }}>
                {lunchText}
                </p>
              )}
            </div>
          </div>
          {idx < card.rows.length - 1 && (
            <div style={{ height: '1px', backgroundColor: '#f0f0f0' }} />
          )}
        </React.Fragment>
      ))}
    </div>
  </div>
);

/* ── Info Card ── */
// const InfoCard = ({ card }) => (
//   <div
//     className="rounded-2xl p-5 ava-card-bg ava-card-mukta">
//     {/* Card header — icon + title */}
//     <div className="flex items-center gap-3 mb-4">
//       {/* Icon badge */}
//       <div
//         className="w-10 h-10 flex items-center justify-center ava-radius-md flex-shrink-0"
//         style={{ backgroundColor: 'var(--secondary-color)' }}
//       >
//         <img
//           src={card.icon}
//           alt={card.title}
//           className="w-5 h-5"
//           style={{ filter: 'brightness(0) invert(1)' }}
//         />
//       </div>
//       <h3
//         className=" ava-text-subheading"
//       >
//         {card.title}
//       </h3>
//     </div>

//     {/* Card rows */}
//     <div className="flex flex-col gap-2.5">
//       {card.rows.map((row) => (
//         <div key={row.id} className="flex items-start gap-3">
//           {/* Row icon */}
//           {row.icon && (
//             <img
//               src={row.icon}
//               alt=""
//               className="w-4 h-4 mt-0.5 flex-shrink-0"
//             />
//           )}
//           {/* Label + value OR single value */}
//           {row.label ? (
//             <div className="flex flex-1 items-start justify-between gap-2 flex-wrap">
//               <span
//                 className="ava-text-body "
//               >
//                 {row.label}
//               </span>
//               <span
//                 className="ava-text-body "
//               >
//                 {row.value}
//               </span>
//             </div>
//           ) : (
//             <span
//               className="ava-text-body"
//             >
//               {row.value}
//             </span>
//           )}
//         </div>
//       ))}
//     </div>
//   </div>
// );
const InfoCard = ({ card }) => (
  <div className="rounded-2xl p-5 ava-card-bg ava-card-mukta">
    {/* Card header — icon + title */}
    <div className="flex items-center gap-3 mb-4">
      <div
        className="w-10 h-10 flex items-center justify-center ava-radius-md flex-shrink-0"
        style={{ backgroundColor: 'var(--secondary-color)' }}
      >
        <img
          src={card.icon}
          alt={card.title}
          className="w-5 h-5"
          style={{ filter: 'brightness(0) invert(1)' }}
        />
      </div>
      <h3 className="ava-text-subheading">{card.title}</h3>
    </div>

    {/* Card rows */}
    <div className="flex flex-col gap-2.5">
      {card.rows.map((row) => {
        const isExternal = row.href?.startsWith('http');
        const valueContent = row.href ? (
          
          <a  href={row.href}
            target={isExternal ? '_blank' : undefined}
            rel={isExternal ? 'noopener noreferrer' : undefined}
            className="ava-text-body hover:underline"
            style={{ color: 'inherit' }}
          >
            {row.value}
          </a>
        ) : (
          <span className="ava-text-body">{row.value}</span>
        );

        return (
          <div key={row.id} className="flex items-start gap-3">
            {row.icon && (
              <img
                src={row.icon}
                alt=""
                className="w-4 h-4 mt-0.5 flex-shrink-0"
              />
            )}
            {row.label ? (
              <div className="flex flex-1 items-start justify-between gap-2 flex-wrap">
                <span className="ava-text-body">{row.label}</span>
                {valueContent}
              </div>
            ) : (
              valueContent
            )}
          </div>
        );
      })}
    </div>
  </div>
);

export default LocationContact;